export type IconName =
  | 'activity'
  | 'alert-circle'
  | 'alert-triangle'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'arrow-up-right'
  | 'bar-chart-3'
  | 'bell'
  | 'briefcase-business'
  | 'calendar-days'
  | 'check'
  | 'check-check'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'circle'
  | 'circle-check'
  | 'circle-help'
  | 'circle-pause'
  | 'circle-plus'
  | 'circle-x'
  | 'clipboard'
  | 'clock-3'
  | 'copy'
  | 'download'
  | 'ellipsis'
  | 'external-link'
  | 'eye'
  | 'file-check-2'
  | 'file-text'
  | 'filter'
  | 'folder'
  | 'grip-vertical'
  | 'hand-coins'
  | 'house'
  | 'info'
  | 'layout-dashboard'
  | 'link'
  | 'loader-circle'
  | 'lock-keyhole'
  | 'lock-keyhole-open'
  | 'mail'
  | 'menu'
  | 'pencil'
  | 'phone'
  | 'pin'
  | 'play'
  | 'plus'
  | 'printer'
  | 'refresh-cw'
  | 'save'
  | 'search'
  | 'settings'
  | 'share-2'
  | 'shield-check'
  | 'sliders-horizontal'
  | 'star'
  | 'tag'
  | 'thumbs-down'
  | 'thumbs-up'
  | 'trash-2'
  | 'trending-down'
  | 'trending-up'
  | 'user-round'
  | 'user-round-plus'
  | 'users-round'
  | 'video'
  | 'wallet'
  | 'x';

export interface IconOptions {
  className?: string;
}

const escapeAttribute = (value: string): string => value
  .replace(/&/g, '&amp;')
  .replace(/"/g, '&quot;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;');

const isSafeIconName = (name: string): boolean =>
  /^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/.test(name);

/**
 * Emit a stable marker for Jinja or vanilla string templates. The icon-only
 * entry owns hydration and the Lucide glyph definitions.
 */
export function Icon(name: IconName, options: IconOptions = {}): string {
  if (!isSafeIconName(name)) throw new TypeError('Invalid Wealth365 icon name');
  const classes = options.className ? ` class="${escapeAttribute(options.className)}"` : '';
  return `<span data-w365-icon="${name}" aria-hidden="true"${classes}></span>`;
}

/** Create the same marker without string concatenation for DOM-based UI. */
export function iconElement(name: IconName, options: IconOptions = {}): HTMLSpanElement | null {
  if (!isSafeIconName(name)) throw new TypeError('Invalid Wealth365 icon name');
  if (typeof document === 'undefined') return null;
  const marker = document.createElement('span');
  marker.setAttribute('data-w365-icon', name);
  marker.setAttribute('aria-hidden', 'true');
  if (options.className) marker.className = options.className;
  return marker;
}
